import type { Maybe } from '@/types'
/* eslint-disable */
export enum FundraisingState {
  WaitingForDonor = 'WaitingForDonor',
  OpenFundraising = 'OpenFundraising',
  ClosedFundraising = 'ClosedFundraising',
  ClosedWaitingForDonor = 'ClosedWaitingForDonor'
}

export type SummaryData = {
  type: number
  amount: number
  fundraisingPayment: number
  childEditionId: number
  childEditionRetentionHash: string | null
  sessionId?: Maybe<string>
}
